/**
 * Helper function that returns an array of options
 * for the facet filters
 * @param {Object} facet facet value to be proceed
 * @param {Array} ref the reverence array with full info for each facet
 * @param {Object} curr default product category selected by user
 * @param {Object} init initial facets state
 * @returns {Array} an array of options for the facet filters
 */
export default function makeOptionsFromFacets(facet, ref, curr, init) {
  if (init) {
    return Object.keys(init)
      .map((key) => {
        const el = ref.find((i) => i.id === Number(key));
        if (el && !curr.value.includes(Number(key))) {
          return {
            label: `${el.name} (${facet?.[key] || 0})`,
            value: el.id || '',
            disabled: !facet?.[key],
            weight: facet?.[key] || 0,
          };
        }
        return undefined;
      })
      .filter((val) => val)
      .sort((a, b) => b.weight - a.weight);
  }
  return [];
}
